function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M21.711 4.236a.983.983 0 0 1 .289.698v19.08c0 .545-.44.986-.985.986H.985A.985.985 0 0 1 0 24.013V.987C0 .44.44 0 .985 0h16.09a.98.98 0 0 1 .696.29zM16.09 9.148c.533 0 .965.433.965.966a.965.965 0 0 1-.965.967H5.418a.966.966 0 0 1 0-1.933h10.671m0 4.606c.533 0 .965.434.965.97a.968.968 0 0 1-.965.973H5.418a.968.968 0 0 1-.965-.972c0-.537.432-.971.965-.971h10.671m0 4.482c.533 0 .965.432.965.966a.965.965 0 0 1-.965.967H5.418a.966.966 0 0 1 0-1.933h10.671m.988-15.852l.014 2.534 2.529.014zm2.953 3.539l-.005.987-3.919-.02a.987.987 0 0 1-.98-.982l-.022-3.928.985-.006H1.97v21.062h18.06z"
}))));

var SvgIconFileWord = function SvgIconFileWord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 22 25",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFileWord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-file-word.22e3ea5c.svg";
export { ForwardRef as ReactComponent };